import { ClientLogger } from 'bernie-client';
import type { Controller, FetchOptions } from 'bernie-core';
import { codeSplit } from 'bernie-core';
import type { PageData } from 'bernie-http';
import type { PageStore } from 'bernie-plugin-mobx';

import { TRIP_PENDING_INVITE_CONTROLLER_INFO } from 'logging/log-events';
import { logDetailedEvent } from 'logging/logger';

import { BASEPATH } from 'constants/basepath';

/**
 * /trips/invite?inviteId=xxx
 */
export class TripPendingInviteController implements Controller {
  public readonly bundles = [];
  public readonly exact = true;
  public readonly pageId = 'page.Trip.PendingInvite,U,80';
  public readonly path = `${BASEPATH}/trips/invite`;
  public readonly routeName = 'trip-pending-invite';
  public readonly component = codeSplit(
    /* istanbul ignore next */
    () => import(/* webpackChunkName: "trip-pending-invite" */ 'views/trip-pending-invite-view')
  );

  public readonly pageName = 'page.Trip.PendingInvite';
  public readonly clickstreamPageName = 'Trip Pending Invite';

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({
      pageId: this.pageId,
      pageName: this.pageName,
      clickstreamPageName: this.clickstreamPageName,
      title: '' // as page title will be set from graph response
    });
  }

  public fetch(options: FetchOptions): Promise<void> {
    const { stores } = options;

    stores.get<PageStore>('page').pageName = this.pageName;
    ClientLogger.setGlobalData('pageName', this.pageName);

    logDetailedEvent(options.logger, TRIP_PENDING_INVITE_CONTROLLER_INFO, {
      request: options.request,
      message: 'Request made to trips-pending-invite-controller'
    });

    return Promise.resolve();
  }
}
